import { render, staticRenderFns } from "./LpuCardsNotFound.vue?vue&type=template&id=7007dc9b&scoped=true&"
import script from "./LpuCardsNotFound.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsNotFound.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsNotFound.vue?vue&type=style&index=0&id=7007dc9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7007dc9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7007dc9b')) {
      api.createRecord('7007dc9b', component.options)
    } else {
      api.reload('7007dc9b', component.options)
    }
    module.hot.accept("./LpuCardsNotFound.vue?vue&type=template&id=7007dc9b&scoped=true&", function () {
      api.rerender('7007dc9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsNotFound.vue"
export default component.exports